import * as React from 'react';
import { useState, createContext } from 'react';


interface DefinitionDataProviderProps {
  children: any;
  overrideFullData:any;
  overrideSetFullData:any;
  overridePolicyMessages:any;
  overrideSetPolicyMessages:any;
}


type MouseSelectionMode = "pan" | "select" | null;
export const MouseSelectionModePan: MouseSelectionMode = "pan";
export const MouseSelectionModeSelect: MouseSelectionMode = "select";

export interface RegionOfInterestContextProps {

    mouseSelectionMode: MouseSelectionMode;
    setMouseSelectionMode: (mode: MouseSelectionMode) => void;
    mouseModeUserSelectable: boolean;
    setMouseModeUserSelectable: (selectable: boolean) => void;
    regionsOfInterest: Array<{  x: number; y: number; width: number; height: number; selectionStart: string, style: string, label: string, labelStyle: string, labelTransform: string  }>;
    setRegionsOfInterest: (regions: Array<{ x: number; y: number; width: number; height: number; selectionStart: string, style: string, label: string, labelStyle: string, labelTransform: string }>) => void;
    selectedRegion: { x: number; y: number; width: number; height: number; type: string };
    setSelectedRegion: (region: { x: number; y: number; width: number; height: number; selectionStart: string, style: string, label: string, labelStyle: string, labelTransform: string }) => void;
    minRegionWidth: number;
    minRegionHeight: number;
}

export interface CurrentAttachmentContextProps {
  currentAttachment: any;
  setCurrentAttachment: (attachment: any) => void;
  currentPage: any;
  setCurrentPage: (page: any) => void;
  rotation: any;
  setRotation: (r: any) => void;
}


export const DataContext = createContext();
export const PolicyContext = createContext();
export const DirtyContext = createContext();
export const RegionOfInterestContext = createContext();
export const CurrentAttachmentContext = createContext();




export const DefinitionDataProvider: React.FC<DefinitionDataProviderProps> = ({
  children,
  overrideFullData,
  overrideSetFullData,
  overridePolicyMessages,
  overrideSetPolicyMessages
}) => {

  const [fullData, setFullData] = overrideSetFullData != null ? [overrideFullData, overrideSetFullData] : useState(null); 
  const [policyMessages, setPolicyMessages] = overrideSetPolicyMessages != null ? [overridePolicyMessages, overrideSetPolicyMessages] : useState(null); 
  const [formDirty, setFormDirty] = useState(false); 
  const [regionsOfInterest, setRegionsOfInterest] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [minRegionWidth, setMinRegionWidth] = useState(0);
  const [minRegionHeight, setMinRegionHeight] = useState(0);
  const [mouseSelectionMode, setMouseSelectionMode] = useState('pan');
  const [mouseModeUserSelectable, setMouseModeUserSelectable] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState(undefined)
  const [currentPage, setCurrentPage] = useState(1)
  const [rotation, setRotation] = useState(0)

  const rawSetPolicyMessages = (messages) => {
    setPolicyMessages(messages);
  }

  return (
    <DataContext.Provider value={[fullData, setFullData]}>
      <PolicyContext.Provider value={[policyMessages, rawSetPolicyMessages]}>
        <CurrentAttachmentContext.Provider value={[currentAttachment, setCurrentAttachment, currentPage, setCurrentPage, rotation, setRotation]}>
          <RegionOfInterestContext.Provider value={{ selectedRegion, setSelectedRegion, regionsOfInterest, setRegionsOfInterest, mouseSelectionMode, setMouseSelectionMode, mouseModeUserSelectable, setMouseModeUserSelectable, minRegionWidth, setMinRegionWidth, minRegionHeight, setMinRegionHeight }}>
                <DirtyContext.Provider value={[formDirty, setFormDirty]}>
                  {children}
              </DirtyContext.Provider>
          </RegionOfInterestContext.Provider>
        </CurrentAttachmentContext.Provider>
      </PolicyContext.Provider>
    </DataContext.Provider>
  );

}

export default DefinitionDataProvider;